/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, e1rmText: NonNullable<unknown> }} Insight_Personal_RecordInputs */

const en_us2_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New record on ${i?.exercise}: ${i?.e1rmText} estimated max strength`)
};

const pt_br2_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Novo recorde em ${i?.exercise}: ${i?.e1rmText} de força máxima estimada`)
};

const es_419_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nuevo récord en ${i?.exercise}: ${i?.e1rmText} de fuerza máxima estimada`)
};

const pt_pt2_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Novo recorde em ${i?.exercise}: ${i?.e1rmText} de força máxima estimada`)
};

const fr_fr2_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nouveau record sur ${i?.exercise} : ${i?.e1rmText} de force max estimée`)
};

const de_de2_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neuer Rekord bei ${i?.exercise}: ${i?.e1rmText} geschätzte Maximalkraft`)
};

const it_it2_insight_personal_record = /** @type {(inputs: Insight_Personal_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nuovo record su ${i?.exercise}: ${i?.e1rmText} di forza massima stimata`)
};

/**
* | output |
* | --- |
* | "New record on {exercise}: {e1rmText} estimated max strength" |
*
* @param {Insight_Personal_RecordInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_personal_record = /** @type {((inputs: Insight_Personal_RecordInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_Personal_RecordInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_personal_record(inputs)
	if (locale === "es-419") return es_419_insight_personal_record(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_personal_record(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_personal_record(inputs)
	if (locale === "de-DE") return de_de2_insight_personal_record(inputs)
	if (locale === "it-IT") return it_it2_insight_personal_record(inputs)
	return en_us2_insight_personal_record(inputs)
});
export { insight_personal_record as "insight.personal_record" }